import { Action } from '@ngrx/store';
import { ActionType } from '@quorum/models/xs-resource';
import { ActionTypeQueryParameters } from '@quorum/models/xs-query';

export const GET_ACTION_TYPES_FROM_SERVER = '[CRM] Get Action Types From Server';
export class GetActionTypesFromServer implements Action {
  readonly feature = 'crm';
  readonly type = GET_ACTION_TYPES_FROM_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: ActionTypeQueryParameters) {}
}

export const GET_ACTION_TYPES_FROM_SERVER_SUCCESS = '[CRM] Get Action Types From Server Success';
export class GetActionTypesFromServerSuccess implements Action {
  readonly feature = 'crm';
  readonly type = GET_ACTION_TYPES_FROM_SERVER_SUCCESS;
  readonly triggerStorageSync = true;
  constructor(public payload: { actionTypes: ActionType[] }) {}
}

export const GET_ACTION_TYPES_FROM_SERVER_FAILURE = '[CRM] Get Action Types Reasons From Server Failure';
export class GetActionTypesFromServerFailure implements Action {
  readonly feature = 'crm';
  readonly type = GET_ACTION_TYPES_FROM_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any }) {}
}

export type ActionTypesAction =
  | GetActionTypesFromServer
  | GetActionTypesFromServerSuccess
  | GetActionTypesFromServerFailure;
